import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function BarcodeScan(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "BarcodeScan", children: [
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.secondary.main, d: "M45.75 6.75H2.25v31.5h43.5V6.75Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M9 6.75H7.5v31.5H9V6.75Zm4.5 0v7.5a.75.75 0 1 1-1.5 0v-7.5h1.5Zm0 24v7.5H12v-7.5a.75.75 0 1 1 1.5 0ZM6 6.75H4.5v31.5H6V6.75Zm-3 0H1.5v31.5H3V6.75Zm15 0v3a.75.75 0 1 1-1.5 0v-3H18Zm0 28.5v3h-1.5v-3a.75.75 0 1 1 1.5 0Zm25.5-28.5v27a.75.75 0 1 1-1.5 0v-27h1.5Zm3 0H45v31.5h1.5V6.75Zm-7.5 0v24a.75.75 0 1 1-1.5 0v-24H39Zm-6 28.5v3h-1.5v-3a.75.75 0 1 1 1.5 0Zm0-28.5v4.5a.75.75 0 1 1-1.5 0v-4.5H33Zm-9 30v1.5h-1.5v-1.5a.75.75 0 1 1 1.5 0Zm3 0v1.5h-1.5v-1.5a.75.75 0 1 1 1.5 0Zm0-30v1.5a.75.75 0 1 1-1.5 0v-1.5H27Zm-3 0v1.5a.75.75 0 1 1-1.5 0v-1.5H24Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M36.75 36a.75.75 0 0 1-.53-.22l-4.8-4.8a.75.75 0 0 1 1.06-1.06l4.8 4.8a.75.75 0 0 1-.53 1.28Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M24 34.5c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M24 33c5.799 0 10.5-4.701 10.5-10.5S29.799 12 24 12s-10.5 4.701-10.5 10.5S18.201 33 24 33Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M38.111 34.242a1.676 1.676 0 1 0-2.37 2.37l4.148 4.147a1.676 1.676 0 1 0 2.37-2.37l-4.148-4.147Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M15.75 25.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 1 1 1.5 0v4.5a.75.75 0 0 1-.75.75Zm6 6a.75.75 0 0 1-.75-.75v-16.5a.75.75 0 1 1 1.5 0v16.5a.75.75 0 0 1-.75.75Zm3 0a.75.75 0 0 1-.75-.75v-16.5a.75.75 0 1 1 1.5 0v16.5a.75.75 0 0 1-.75.75Zm6-3a.75.75 0 0 1-.75-.75v-10.5a.75.75 0 1 1 1.5 0v10.5a.75.75 0 0 1-.75.75Z"
      }
    )
  ] });
}
BarcodeScan.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "BarcodeScan"
};
validateTidalLicense();
export {
  BarcodeScan
};
//# sourceMappingURL=BarcodeScan.js.map
